import React from "react";
import Banner from "../../components/Banner";
import Spinner from "../../components/Spinner";
import axios from "axios";
import "../../css/Wireframe.css";

// Helper constants (flattened, no imports)
const API = localStorage.getItem("assethost");
const usernameRegex = /^(?!\s*$)[-_a-zA-Z0-9 ]*$/;
const usernameError =
  "Username should only contain letters, digits, dash, or underscore";

export default class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      errors: {},
      loading: false,
      msg: "",
      toastColor: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleGetCode = this.handleGetCode.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.validate = this.validate.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  validate() {
    let errors = {};
    let valid = true;
    if (!this.state.username || !this.state.username.trim()) {
      errors.username = "Username is required";
      valid = false;
    } else if (!usernameRegex.test(this.state.username)) {
      errors.username = usernameError;
      valid = false;
    }
    this.setState({ errors, valid });
    return valid;
  }

  handleGetCode(e) {
    if (e) e.preventDefault();
    this.setState({ loading: true, msg: "", toastColor: "" });
    if (!this.validate()) {
      this.setState({ loading: false });
      return;
    }

    axios
      .get(API + `/security/generateotpcode/${this.state.username}`)
      .then(() => {
        sessionStorage.setItem("username", this.state.username);
        window.location.href = "/auth/forgot/reset";
      })
      .catch((err) => {
        this.setState({
          msg: err?.response?.data?.message || err?.data?.message || "Failed to get OTP",
          toastColor: "danger",
          loading: false,
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  handleCancel(e) {
    if (e) e.preventDefault();
    window.history.back();
  }

  render() {
    const s = this.state;

    if (s.loading) {
      return <Spinner className="" />;
    }

    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }
    return (
      <div className="min-vh-100 d-flex flex-column pb-2">
        <Banner title="Forgot Password – Get Reset Code" />
        {divMsg}
        <div className="d-flex flex-column align-items-center mt-8 flex-grow-1">
          <p className="mb-6 text-center">
            Please enter your username and get reset code via your cellphone
            number or email.
          </p>
          <form
            className="wrapper space-y-3"
            autoComplete="off"
            onSubmit={this.handleGetCode}
          >
            <div className="input-group w-100">
              <label className="input-group-text">Username</label>
              <input
                id="username"
                name="username"
                type="text"
                className={`form-control ${
                  s.errors.username ? " !border-red-500" : ""
                }`}
                value={s.username}
                onChange={this.handleChange}
                autoFocus
                required
              />
              {s.errors.username && (
                <span className="input-group-error">{s.errors.username}</span>
              )}
            </div>
            <button type="submit" className="btn btn-primary">
              Get Code
            </button>
            <button className="btn btn-primary" onClick={this.handleCancel}>
              Cancel
            </button>
            {s.errors.general && (
              <div className="alert alert-danger mt-2">{s.errors.general}</div>
            )}
          </form>
        </div>
        
      </div>
    );
  }
}
